import PackageRequestsResolvedTable from "./package-requests-resolved-table";

export default PackageRequestsResolvedTable;
